export const CONVERSATIONS_LIST_CONVERSATIONS_PER_PAGE = 30;